export const ACCESS_REQUEST_ADD_MEMBER = "ACCESS_REQUEST_ADD_MEMBER"
export const UPDATE_ACCESS_REQUEST_ADD_MEMBER_DIALOG_OPEN =
  "UPDATE_ACCESS_REQUEST_ADD_MEMBER_DIALOG_OPEN"
export const DENY_REQUEST = "DENY_REQUEST"
export const RECEIVE_POSSIBLE_MATCHES = "RECEIVE_POSSIBLE_MATCHES"
export const FETCH_POSSIBLE_MATCHES = "FETCH_POSSIBLE_MATCHES"
export const ACCESS_REQUEST_GRANT_ACCESS = "ACCESS_REQUEST_GRANT_ACCESS"
export const UPDATE_ACCESS_REQUEST_ERROR = "UPDATE_ACCESS_REQUEST_ERROR"
export const GET_MAGIC_PASSWORD = "GET_MAGIC_PASSWORD"
export const UPDATE_MAGIC_PASSWORD = "UPDATE_MAGIC_PASSWORD"
export const RECEIVE_MAGIC_PASSWORD = "RECEIVE_MAGIC_PASSWORD"
export const UPDATE_MATCHED_CONSTITUENT_ID = "UPDATE_MATCHED_CONSTITUENT_ID"
export const RESEND_ONBOARDING_EMAIL = "RESEND_ONBOARDING_EMAIL"
export const FETCH_NETWORK_ACCESS_REQUESTS = "FETCH_NETWORK_ACCESS_REQUESTS"
export const RECEIVE_NETWORK_ACCESS_REQUESTS = "RECEIVE_NETWORK_ACCESS_REQUESTS"
export const CLOSE_REQUEST_SUCCESS = "CLOSE_REQUEST_SUCCESS"
export const REVERT_ACCESS_REQUEST_DRAWER = "REVERT_ACCESS_REQUEST_DRAWER"
export const UPDATE_SELECTED_ACCESS_REQUEST = "UPDATE_SELECTED_ACCESS_REQUEST"
export const UPDATE_CLOSED_REQUEST_IDS = "UPDATE_CLOSED_REQUEST_IDS"
export const ADD_CONSTITUENT = "ADD_CONSTITUENT"
export const TURN_OFF_MEMBER_ACCESS_SAVING = "TURN_OFF_MEMBER_ACCESS_SAVING"

export const updateAccessRequestAddMemberDialogOpen = (open, accessRequest) => ({
  type: UPDATE_ACCESS_REQUEST_ADD_MEMBER_DIALOG_OPEN,
  open,
  accessRequest,
})

export const turnOffMemberAccessSaving = () => ({
  type: TURN_OFF_MEMBER_ACCESS_SAVING,
})

export const accessRequestAddMember = (accessRequestId, constituent, success, error) => ({
  type: ACCESS_REQUEST_ADD_MEMBER,
  accessRequestId,
  constituent,
  success,
  error,
})

export const denyRequest = (accessRequestId, success, error) => ({
  type: DENY_REQUEST,
  accessRequestId,
  success,
  error,
})

export const fetchPossibleMatches = (accessRequestId, success, error) => ({
  type: FETCH_POSSIBLE_MATCHES,
  accessRequestId,
  success,
  error,
})

export const receivePossibleMatches = (possibleMatchDict) => ({
  type: RECEIVE_POSSIBLE_MATCHES,
  possibleMatchDict,
})

export const accessRequestGrantAccess = (accessRequestId, constituentId, success, error) => ({
  type: ACCESS_REQUEST_GRANT_ACCESS,
  accessRequestId,
  constituentId,
  success,
  error,
})

export const updateAccessRequestError = (error) => ({
  type: UPDATE_ACCESS_REQUEST_ERROR,
  error,
})

export const getMagicPassword = (success, error) => ({
  type: GET_MAGIC_PASSWORD,
  success,
  error,
})

export const updateMagicPassword = (magicPassword, success, error) => ({
  type: UPDATE_MAGIC_PASSWORD,
  magicPassword,
  success,
  error,
})

export const receiveMagicPassword = (magicPassword) => ({
  type: RECEIVE_MAGIC_PASSWORD,
  magicPassword,
})

export const updateMatchedConstituentId = (id) => ({
  type: UPDATE_MATCHED_CONSTITUENT_ID,
  id,
})

export const resendOnboardingEmail = (constituentId, success, error) => ({
  type: RESEND_ONBOARDING_EMAIL,
  constituentId,
  success,
  error,
})

export const receiveNetworkAccessRequests = (networkAccessRequests) => ({
  type: RECEIVE_NETWORK_ACCESS_REQUESTS,
  networkAccessRequests,
})

export const fetchNetworkAccessRequests = (success, error) => ({
  type: FETCH_NETWORK_ACCESS_REQUESTS,
  success,
  error,
})

export const closeRequestSuccess = () => ({
  type: CLOSE_REQUEST_SUCCESS,
})

export const revertAccessRequestDrawer = () => ({
  type: REVERT_ACCESS_REQUEST_DRAWER,
})

export const updateSelectedAccessRequest = (selectedAccessRequest) => ({
  type: UPDATE_SELECTED_ACCESS_REQUEST,
  selectedAccessRequest,
})

export const updateClosedRequestIds = (ids) => ({
  type: UPDATE_CLOSED_REQUEST_IDS,
  ids,
})

export const addConstituent = (constituent, success, error) => ({
  type: ADD_CONSTITUENT,
  constituent,
  success,
  error,
})
